import Nav from "./components/Nav";
import BlogHero from "./blog-sections/BlogHero";
import BlogListing from "./blog-sections/BlogListing";
import BlogFooter from "./blog-sections/BlogFooter";

export default function Blog() {
  return (
    <>
      <Nav route="blog" />
      <BlogHero />
      <BlogListing />
      <BlogFooter />
    </>
  );
}
